import { render } from "./FooterLeft.vue?vue&type=template&id=8488a51c&scoped=true"
import script from "./FooterLeft.vue?vue&type=script&lang=js"
export * from "./FooterLeft.vue?vue&type=script&lang=js"

import "./FooterLeft.vue?vue&type=style&index=0&id=8488a51c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8488a51c"],['__file',"src/components/FooterLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8488a51c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8488a51c', __exports__)) {
    api.reload('8488a51c', __exports__)
  }
  
  module.hot.accept("./FooterLeft.vue?vue&type=template&id=8488a51c&scoped=true", () => {
    api.rerender('8488a51c', render)
  })

}


export default __exports__